var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Set PHP Version per Domain ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "mb-0"
                    },
                    [
                      _vm._v(
                        " Select the domains that you wish to change from the table, then apply a PHP version from the list. "
                      )
                    ]
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-end",
                  attrs: {
                    cols: "12",
                    md: "5"
                  }
                },
                [
                  _c("gg-select", {
                    attrs: {
                      label: "PHP Version",
                      "hide-details": "",
                      items: _vm.phpVersions,
                      loading: _vm.loadingVersions
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [_vm._v(_vm._s(_vm.formatPhpVer(item)))]
                        }
                      },
                      {
                        key: "item",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [_vm._v(_vm._s(_vm.formatPhpVer(item)))]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedVersion,
                      callback: function callback($$v) {
                        _vm.selectedVersion = $$v
                      },
                      expression: "selectedVersion"
                    }
                  }),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mb-1 ml-4",
                      attrs: {
                        disabled: !_vm.canApply,
                        loading: _vm.submitting
                      },
                      on: {
                        click: _vm.applyPhpVersion
                      }
                    },
                    [_vm._v(" Apply ")]
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-data-table", {
                    attrs: {
                      "show-select": "",
                      "item-key": "vhost",
                      "sort-by": "vhost",
                      headers: _vm.headers,
                      items: _vm.vhostVersions,
                      loading: _vm.loadingVhost
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.version",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatPhpVer(item.version)) + " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.php_fpm",
                        fn: function fn(_ref4) {
                          var item = _ref4.item
                          return [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  color: "primary",
                                  size: "24"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.php_fpm == 1 ? "mdi-check-bold" : ""
                                  )
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedVhost,
                      callback: function callback($$v) {
                        _vm.selectedVhost = $$v
                      },
                      expression: "selectedVhost"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }